/*
 * Public API Surface of q2-angular-cms
 */

export * from './lib/q2-angular-cms.module';
